(() => {
	let $activeDropdown;
	let isAnimating = false;

	const $dropdowns = $('[data-dropdown]');
	const $toggles = $('[data-toggle-dropdown]');

	// Init Toggles
	// ----------------------------------------

	$toggles.each(function () {
		const $toggle = $(this);
		const $dropdown = $(`[data-dropdown="${$toggle.data('toggle-dropdown')}"]`);

		$toggle.on('click', async (e) => {
			e.preventDefault();
			toggleDropdown($dropdown);
		});
	});

	// Animations
	// ----------------------------------------

	$dropdowns.each(function () {
		const $dropdown = $(this);
		const $bubble = $dropdown.find('.bubble');
		const dropdownId = $dropdown.data('dropdown');
		const timeline = gsap.timeline({
			paused: true,
			onReverseComplete: () => $dropdown.css('display', 'none')
		});

		// Animate dropdown
		timeline
			.set($dropdown, {
				height: 'auto',
				display: 'block'
			})
			.from($dropdown, {
				duration: 0.5,
				ease: 'power2.inOut',
				clearProps: 'height',
				height: 0
			});

		// Animate bubble link
		if ($bubble.length) {
			timeline
				.set($dropdown, {
					overflow: 'visible'
				})
				.fromTo(
					$bubble,
					{
						autoAlpha: 0,
						scale: 0.8,
						xPercent: -50,
						yPercent: 50
					},
					{
						duration: 0.3,
						autoAlpha: 1,
						scale: 1,
						xPercent: -50,
						yPercent: 50
					}
				);
		}

		// Animate contents
		switch (dropdownId) {
			case 'search-dropdown':
				timeline.add(getSearchAnim($dropdown), 0.3);
				break;

			case 'shop-dropdown':
				timeline.add(getShopAnim($dropdown), 0.3);
				break;
		}

		$dropdown.data('anim', timeline);
	});

	function getSearchAnim($dropdown) {
		return gsap.timeline().fromTo(
			$dropdown.find('.dropdown__inner'),
			{
				opacity: 0
			},
			{
				duration: 0.5,
				opacity: 1
			}
		);
	}

	function getShopAnim($dropdown) {
		return gsap.timeline().fromTo(
			$dropdown.find('.dropdown__item'),
			{
				y: '-25px',
				opacity: 0
			},
			{
				duration: 0.3,
				ease: 'back.out(1.7)',
				y: '0px',
				opacity: 1,
				stagger: 0.07
			}
		);
	}

	// Dropdown State
	// ----------------------------------------

	async function toggleDropdown($dropdown) {
		// close the active dropdown
		if ($activeDropdown && $activeDropdown.data('dropdown') != $dropdown.data('dropdown')) {
			await closeDropdown($activeDropdown);
		}

		// Toggle
		if (!$activeDropdown) {
			await openDropdown($dropdown);
		} else {
			await closeDropdown($dropdown);
		}
	}

	async function openDropdown($dropdown) {
		if (isAnimating) return;
		isAnimating = true;

		// Set active state on all toggles
		$(`[data-toggle-dropdown="${$dropdown.data('dropdown')}"]`).addClass('-dropdown-open');

		await $dropdown.data('anim').play();

		isAnimating = false;
		$activeDropdown = $dropdown;
		$dropdown.addClass('-open');
	}

	async function closeDropdown($dropdown) {
		if (isAnimating) return;
		isAnimating = true;

		// Remove active state on all toggles
		$(`[data-toggle-dropdown="${$dropdown.data('dropdown')}"]`).removeClass('-dropdown-open');

		await $dropdown.data('anim').reverse();

		isAnimating = false;
		$activeDropdown = null;
		$dropdown.removeClass('-open');
	}

	// Events
	// ----------------------------------------

	$WINDOW.on('page:load-started', () => {
		if ($activeDropdown) {
			closeDropdown($activeDropdown);
		}
	});

	$WINDOW.on('resize:horizontal', () => {
		$dropdowns.each(function () {
			$(this).data('anim').invalidate();
		});

		if ($activeDropdown) {
			closeDropdown($activeDropdown);
		}
	});

	$DOC.click((e) => {
		if (!$activeDropdown || !$activeDropdown.length) return;

		const $target = $(e.target);
		const $dropdown = $target.closest('[data-dropdown]');
		const $toggle = $target.closest('[data-toggle-dropdown]');

		if (!$dropdown.length && !$toggle.length) {
			closeDropdown($activeDropdown);
		}
	});
})();
